import { render, staticRenderFns } from "./game-course-rounds.vue?vue&type=template&id=49f985ca&scoped=true"
import script from "./game-course-rounds.vue?vue&type=script&lang=js"
export * from "./game-course-rounds.vue?vue&type=script&lang=js"
import style0 from "./game-course-rounds.vue?vue&type=style&index=0&id=49f985ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f985ca",
  null
  
)

export default component.exports